declare namespace $ {

	type $mol_locale_select_langs__1 = $mol_type_enforce<
		`en`
		,
		string
	>
	export class $mol_locale_select extends $mol_select {
		langs( ): readonly(string)[]
	}
	
}

//# sourceMappingURL=select.view.tree.d.ts.map